import { render } from "./EmailMange.vue?vue&type=template&id=16c1475c&scoped=true"
import script from "./EmailMange.vue?vue&type=script&lang=js"
export * from "./EmailMange.vue?vue&type=script&lang=js"

import "./EmailMange.vue?vue&type=style&index=0&id=16c1475c&lang=scss&scoped=true"
import "./EmailMange.vue?vue&type=style&index=1&id=16c1475c&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c1475c"]])

export default __exports__